export default __webpack_public_path__ + "static/media/sad-light.505b8371.svg";